module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Lu_Zeit.24225ec6.png";